export default function useParentMessage() {
    
  const scrollToTop = () => {
    window.parent.postMessage("scrollToTop::", "*");
    window.scrollTo(0, 0)
  };


  const scrollToId = (idName: string) => {
    const el = document.getElementById(idName);
    if(el !== null){
      let distance = window.pageYOffset + el.getBoundingClientRect().top;
 
      window.parent.postMessage("scrollToId::" + distance, "*");
    }
  }

  const forceGoToPayment = (paymentUrl: string) => {
    window.parent.postMessage("paymentLink::" + paymentUrl, "*")
  }


  return {
    forceGoToPayment,
    scrollToId,
    scrollToTop
  };
}

